import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'
import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import useReduxAction from '@hooks/useReduxAction'

const watchEntityKeys = ['customFieldSets']

function useCustomFieldSets(options = {}){
  const { entityKey, filters, performHttpRequests } = options
  const {
    entity_type: filterEntityType,
    owner_id: filterOwnerId,
    owner_type: filterOwnerType,
  } = filters || {}

  const {
    updatedEntities: { customFieldSets: customFieldSetsUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { loading: loadingCustomFieldSets } = useReduxAction(
    'customFieldSets',
    'loadCustomFieldSets',
    {
      entityKey,
      ...defaultRequestOptions.customFieldSet,
      ...filters,
    },
    [performHttpRequests, filters],
    {
      shouldPerformFn: ({ loading }) => performHttpRequests && !loading,
    },
  )

  const entities = useSelector(reduxState => reduxState.entities)
  const { customFieldSets } = entities

  const filteredCustomFieldSets = useMemo(() => {
    const filtered = Object.values(customFieldSets).filter((customFieldSet) => {
      const { entity_type, owner_id, owner_type } = customFieldSet

      const matchOwnerId = matchFilterNumber(owner_id, filterOwnerId)
      const matchOwnerType = filterOwnerType ? owner_type === filterOwnerType : true
      const matchEntityType = filterEntityType ? entity_type === filterEntityType : true

      return matchOwnerId && matchOwnerType && matchEntityType
    })

    return sortArrayBy(filtered, 'desc', 'id')
  }, [customFieldSetsUpdatedAt, JSON.stringify(options)])

  return {
    filteredCustomFieldSets,
    hasCustomFieldSets: !!filteredCustomFieldSets.length,
    loadingCustomFieldSets,
  }
}

export default useCustomFieldSets
